/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Architecture12Inputs */

const en_cv_extract_form_enum_architecture12 = /** @type {(inputs: Cv_Extract_Form_Enum_Architecture12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architecture`)
};

const de_cv_extract_form_enum_architecture12 = /** @type {(inputs: Cv_Extract_Form_Enum_Architecture12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architektur`)
};

/**
* | output |
* | --- |
* | "Architecture" |
*
* @param {Cv_Extract_Form_Enum_Architecture12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_architecture12 = /** @type {((inputs?: Cv_Extract_Form_Enum_Architecture12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Architecture12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_architecture12(inputs)
	return en_cv_extract_form_enum_architecture12(inputs)
});
export { cv_extract_form_enum_architecture12 as "cv_extract_form_enum_ARCHITECTURE" }